module.exports = __webpack_public_path__ + "img/enterprise-institution-2.8a56c334.png";